// Gestione consenso cookie (GDPR). La scelta è memorizzata in localStorage
// e rispettata alle visite successive. Il marketing (Meta Pixel) parte solo
// con consenso esplicito; i cookie strettamente necessari restano sempre attivi.
import { grantMarketingConsent, revokeMarketingConsent } from "./metaPixel";

const CONSENT_KEY = "loi-consent";

export const getStoredConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
  } catch {
    return null;
  }
};

export const saveConsent = (marketing) => {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ necessary: true, marketing: !!marketing, ts: Date.now() }));
  if (marketing) grantMarketingConsent();
  else revokeMarketingConsent();
};

// All'avvio: applica la scelta memorizzata (nessun banner se già espressa)
export const bootConsent = () => {
  if (getStoredConsent()?.marketing) grantMarketingConsent();
};
